import React, { useEffect } from "react";
import "./faq.css";
import Common_title from "../../common-components/common-title/Common_title";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { getFaq } from "../../../features/faq/Slice";

const Faq = ({faqItems}) => {
  
 
  // Flatten the nested Faqs arrays from all categories
  // const faqItems = faqs
  //   ? faqs.reduce((acc, category) => {
  //       return acc.concat(category.Faqs || []);
  //     }, [])
  //   : [];

  return (
    <section className="faq_Section">
      <div className="container">
        <Common_title title="Faq" />
        <div className="accordion_sec">
          <Accordion defaultActiveKey="0" flush>
            {faqItems && faqItems.length > 0 ? (
              faqItems.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={faq.id}>
                  <Accordion.Header>{faq.question}</Accordion.Header>
                  <Accordion.Body>
                    <div
                      className="acc-content"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              ))
            ) : (
              <div className="no-data">No FAQs Available</div>
            )}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Faq;